import { Link, NavLink } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Navbar() {
  const { user } = useAuth();
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-5 md:px-10 h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#E0007A] shadow-[0_0_20px_-4px_rgba(224,0,122,0.8)]">
            <Sparkles className="h-4 w-4 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display text-lg tracking-tight">
            Prompt<span className="text-[#00E5FF]">Hub</span>
          </span>
        </Link>

        <nav className="flex items-center gap-1 md:gap-3">
          <NavLink
            to="/"
            end
            data-testid="nav-link-gallery"
            className={({ isActive }) =>
              `font-mono-label px-3 py-2 rounded-md transition-colors ${
                isActive ? "text-white bg-white/5" : "text-white/60 hover:text-white"
              }`
            }
          >
            Gallery
          </NavLink>
          <NavLink
            to="/blog"
            data-testid="nav-link-blog"
            className={({ isActive }) =>
              `font-mono-label px-3 py-2 rounded-md transition-colors ${
                isActive ? "text-white bg-white/5" : "text-white/60 hover:text-white"
              }`
            }
          >
            Blog
          </NavLink>
          {user && user.role === "admin" ? (
            <NavLink
              to="/admin-dashboard"
              data-testid="nav-link-dashboard"
              className="font-mono-label px-3 py-2 rounded-md text-[#00E5FF] hover:bg-white/5"
            >
              Dashboard
            </NavLink>
          ) : (
            <NavLink
              to="/admin-login"
              data-testid="nav-link-admin"
              className="font-mono-label px-3 py-2 rounded-md text-white/60 hover:text-white"
            >
              Admin
            </NavLink>
          )}
        </nav>
      </div>
    </header>
  );
}
